import {
  GridColDef,
  isAutogeneratedRow,
} from "@mui/x-data-grid-premium";
import { Chip, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useAppTranslation } from "../../hooks/useAppTranslation";

const RoleChip = ({ role }: { role: string }) => {
  const { t } = useAppTranslation("common");

  const config: any = {
    admin: { label: t("Admin"), color: "error" },
    accountant: { label: t("Księgowy"), color: "primary" },
    external: { label: t("Zewnętrzny"), color: "default" },
  };

  const c = config[role] || config.external;

  return (
    <Chip
      label={c.label}
      size="small"
      color={c.color}
      variant={role === "external" ? "outlined" : "filled"}
    />
  );
};

export const createAdminUserColumns = (
  t: (key: string, options?: any, ns?: any) => string,
  onOpenUser: (user: any) => void
): GridColDef<any>[] => [
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    sortable: true,
    filterable: true,
    aggregable: false,
  },
  {
    field: "display_name",
    headerName: t("Nazwa"),
    flex: 1,
    sortable: true,
    filterable: true,
    aggregable: false,
  },
  {
    field: "role",
    headerName: t("Rola"),
    width: 160,
    sortable: true,
    filterable: true,
    aggregable: false,
    renderCell: (params) => {
      if (isAutogeneratedRow(params.row)) {
        return null;
      }

      return <RoleChip role={params.value} />;
    },
  },
  {
    field: "companies_count",
    headerName: t("Firmy"),
    width: 120,
    type: "number",
    sortable: true,
    filterable: true,
    aggregable: false,
    valueGetter: (_value, row) => {
      if (isAutogeneratedRow(row)) {
        return undefined;
      }

      return Number(row.companies_count ?? 0);
    },
    renderCell: (params) => {
      if (isAutogeneratedRow(params.row)) {
        return params.formattedValue ?? params.value ?? null;
      }

      const count = Number(params.row.companies_count ?? 0);

      return (
        <Tooltip title={`${t("Liczba firm")}: ${count}`}>
          <Chip
            label={count}
            size="small"
            variant="outlined"
            sx={{ opacity: count === 0 ? 0.6 : 1 }}
          />
        </Tooltip>
      );
    },
  },
  {
    field: "is_active",
    headerName: "Status",
    width: 140,
    type: "boolean",
    sortable: true,
    filterable: true,
    aggregable: false,
    renderCell: (params) => {
      if (isAutogeneratedRow(params.row)) {
        return null;
      }

      return (
        <Chip
          label={params.value ? t("Aktywny") : t("Nieaktywny")}
          size="small"
          color={params.value ? "success" : "default"}
          variant={params.value ? "filled" : "outlined"}
        />
      );
    },
  },
  {
    field: "open",
    headerName: "",
    width: 80,
    sortable: false,
    filterable: false,
    aggregable: false,
    disableColumnMenu: true,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      if (isAutogeneratedRow(params.row)) {
        return null;
      }

      return (
        <Tooltip title={t("Edytuj użytkownika")}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onOpenUser(params.row);
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      );
    },
  },
];